// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-page{padding:10px 10px 200px}.app-page .wrapper .block{margin-top:30px}.app-page .wrapper .block ol{margin-left:20px;margin-top:30px}.app-page .wrapper .block ol li{margin:5px 0}.app-page .wrapper .block .spoiler{margin-top:5px}.app-page .wrapper .block .spoiler img{margin:5px;transition:opacity .2s ease;width:100px}.app-page .wrapper .block .spoiler img:hover{opacity:.9}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
